var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobilePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01 12.75a.688.688 0 00-.442.156.494.494 0 00-.184.375c0 .141.066.276.184.376.117.1.276.155.443.155h2.505a.687.687 0 00.443-.155.494.494 0 00.183-.376.494.494 0 00-.183-.375.687.687 0 00-.443-.156H5.01zM2.506 0C1.841 0 1.204.224.734.622.264 1.021 0 1.562 0 2.125v12.75c0 .564.264 1.104.734 1.503.47.398 1.107.622 1.771.622h7.516c.664 0 1.302-.224 1.771-.622.47-.399.734-.94.734-1.503V2.125c0-.564-.264-1.104-.733-1.503C11.322.224 10.686 0 10.02 0H2.505zM1.253 2.125c0-.282.132-.552.367-.751.234-.2.553-.312.885-.312h7.516c.332 0 .65.112.886.312.235.199.367.47.367.751v12.75a.988.988 0 01-.367.751c-.235.2-.554.312-.886.312H2.505c-.332 0-.65-.112-.885-.312a.988.988 0 01-.367-.751V2.125z",
    fill: "#979797"
  })));
}

export default SvgMobilePhone;